export const openDocument = (documentId) => {
  window.open('https://mamorepo.com/document/' + documentId + '.html', documentId);
}
